import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=507ff220&scoped=true"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"
import style0 from "./edit.vue?vue&type=style&index=0&id=507ff220&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../szc.cycz.cc/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "507ff220",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/szc.cycz.cc/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('507ff220')) {
      api.createRecord('507ff220', component.options)
    } else {
      api.reload('507ff220', component.options)
    }
    module.hot.accept("./edit.vue?vue&type=template&id=507ff220&scoped=true", function () {
      api.rerender('507ff220', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customerInfo/customerContract/edit.vue"
export default component.exports